export default {
    activePedido: { forma_pago: '', modo_preparacion: '', cambio: null, forma_envio: '' },
    direccionPedido: {
        calle: '',
        numero: '',
        adicional: '',
        cp: '',
        municipio: '',
        provincia: '',
        pais: '',
        codigoPais: '',
        coordenadas: []
    },
    restaurantePedido: null,
    restauranteObjPedido: {
        imagenListado: "",
        nombre: "",
        imagen: ""
    },
    negocioPedido: null,
    negocioObjPedido: {
        imagenListado: "",
        nombre: "",
        imagen: ""
    },
    continuarPedido: false, //snakcbar de continuar pedido
    pedidoPendiente: {
        pedido: '',
        restaurante: '',
        restauranteObj: { nombre: '' },
        negocio: '',
        negocioObj: { nombre: '' },
        direccion: '',
        carrito: ''
    },
    /** Lo utilizamos para al elegir restaurante comprobar si hay
     * pedido en curso y ofrecer modal de cambio
     */
    datosCompararNuevo: {
        restaurante: '',
        restauranteObj: { nombre: '' },
        negocio: '',
        negocioObj: { nombre: '' },
        forma_envio: ''
    },
    ultimosPedidos: [{}],//el objeto 0 es el último pedido
    /** Valor booleano que indica si el carrito en cliente es dinstito
     * a los valores almacenados en servidor. El array contiene el carrito
     * corregido según los valores de servidor
     */
    carritoComprobadoServidorCambiado: false,
    carritoComprobadoServidor: [],
    //nuevo
    carrito: { productos: [], numero_producto: 0, precio_total: 0 },
    ultimoPedido: {},
    loadingCarrito: false,
    loadingQuantity: false,
    loadingFinalizar: false,

    continuePedido: false,
    activeCat: {
        id: null,
        nombre: ''
    }, //activeCat.id y activeCat.nombre
    activeProductDialog: false,
    dialogCambioCarrito: false,
    cambioCarrito: {},                             //Carrito temporal si detecta cambios
    dialogDireccion: false,
    confirmarPagoDialog: false,
    loadOptions: false,
    loadingDialog: false,
    seleccionOpciones: [],
    opcionesActiveProduct: false,
    activeProduct: {
        img: false,
        name: false,
        prize: false,
        //opciones: false
    }, // 
    activeProductDialogActivo: null,
    movimientoDialog: 'avanza',                // avanza || retrocede
    activeRestaurant: '',
    addressObject: {
        calle: '',                  //Direccion de Google Maps
        numero: '',
        adicional: '',
        cp: '',
        municipio: '',
        provincia: '',
        pais: '',
        codigoPais: '',
        coordenadas: []
    },
    codigoProvinciaAnterior: '',
    codigoProvinciaDiferente: false,
    pasoFinalizar: 1,
    usuarioConfirmado: false,
    stripeRequireAction: false,
    stripeRequireActionUrl: '',
    stripeDialog: false,
    modoEditarDireccion: false,
    newCard: null,
    choosenCard: null,
    guardarTarjeta: true,
    pedidoMinimo: null,
    recargoPedido: null
}